import usePlaidModal from "./usePlaidModal";
import { useSubmitPlaidToken } from "./useSubmitPlaidToken";

type Mode = "update" | "link";

export const usePlaidBankAccountFlow = (mode: Mode) => {
  const { mutate, isPending, isSuccess, isError } = useSubmitPlaidToken(mode);

  const { openPlaidModal, isPlaidModalLoading, plaidError } = usePlaidModal({
    onSubmit: (publicToken) => {
      mutate({ publicToken });
    },
    mode: mode,
  });

  return {
    openPlaidModal,
    isPending: isPending || isPlaidModalLoading,
    isSuccess,
    plaidError,
    plaidAccountCreateError: isError,
  };
};

export default usePlaidBankAccountFlow;
